export const removeAccents = (str) => {
    var AccentsMap = [
        'aàảãáạăằẳẵắặâầẩẫấậ',
        'AÀẢÃÁẠĂẰẲẴẮẶÂẦẨẪẤẬ',
        'dđ',
        'DĐ',
        'eèẻẽéẹêềểễếệ',
        'EÈẺẼÉẸÊỀỂỄẾỆ',
        'iìỉĩíị',
        'IÌỈĨÍỊ',
        'oòỏõóọôồổỗốộơờởỡớợ',
        'OÒỎÕÓỌÔỒỔỖỐỘƠỜỞỠỚỢ',
        'uùủũúụưừửữứự',
        'UÙỦŨÚỤƯỪỬỮỨỰ',
        'yỳỷỹýỵ',
        'YỲỶỸÝỴ'
    ];
    for (var i = 0; i < AccentsMap.length; i++) {
        var re = new RegExp('[' + AccentsMap[i].substring(1) + ']', 'g');
        var char = AccentsMap[i][0];
        str = str.replace(re, char).replace(/\s/g, '');
    }
    return str;
};

function isFloat(value) {
    const number = Number(value);
    return !isNaN(number);
}

function isInt(value) {
    const number = Number(value);
    return !isNaN(number) && Number.isInteger(number);
}

function isString(value) {
    return typeof value === 'string';
}

export const validateDataType = (value, type) => {
    switch (type) {
        case 'float':
            return isFloat(value);
        case 'int':
            return isInt(value);
        default:
            return isString(value);
    }
};
